import { useEffect } from "react";
import Header from "../components/Header/Header";

type Props = {};

const TermsAndCondition = (props: Props) => {
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const userToken: string = currentUser?.jwtToken;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div className="h-[75px] z-10 fixed mx-10 ">
        <Header
          position={"fixed"}
          isLoggedIn={userToken ? true : false}
          logo={"Yes"}
        />
      </div>
      <div
        className={`rounded-[8px] lg:mx-[30px] m-[20px] lg:mx-8 mx-2 p-[20px] lg:p-[5px] ${
          window.location.pathname === "/profile/terms-and-condition"
            ? ""
            : "mt-[100px]"
        } `}
      >
        <div className="text-white mb-2 bg-[#ED1C24] rounded-3xl width-full text-center h-[80px] font-poppins font-semibold lg:text-2xl md:text-2xl text-xl pt-5">
          Terms & Conditions
        </div>
        <div className=" p-5 font-poppins">
          <div className="flex-row flex items-center">
            <p className="font-bold text-sm ">BUSINESS INFORMATION: </p>
            <p className="ml-2 text-sm">
              CarRental is a product owned and operated by Wandrstar Travel
              Technologies Pvt Ltd and Travel Life LLC.
            </p>
          </div>
          <p className="mt-6 text-sm ">
            This agreement ("<b>Agreement</b>") is entered into between you, the
            User, or you, and <mark>Car Rental LLC</mark>("Car Rental," "we,"
            "our," or "us"). By using the Services provided by Car Rental, you
            agree to be bound by the terms and conditions set forth in this
            Agreement. If you do not agree to these terms and conditions, you
            may not use the Services. In case of any conflict or discrepancy
            between these Terms and Conditions and any other provisions, terms,
            or agreements between Car Rental and you, the provisions and terms
            of these Terms of Use will prevail. If you have any questions
            regarding the content of this agreement, please contact us.
          </p>

          <ol className="list-decimal mt-4 ml-4 text-sm">
            <li className="mt-4 text-sm">
              <p className="font-bold text-sm ml-4">ABOUT Car Rental</p>
              <ol className="list-disc text-sm ml-4">
                <li className="mt-4 text-sm">
                  Welcome to Car Rental ("<b>Platform</b>"), an online
                  marketplace that connects Owners and Drivers for the purpose
                  of reserving Parking Spaces. By accessing or using the
                  Platform, you agree to be bound by these Terms and Conditions
                  ("<b>Terms</b>").
                </li>
                <li className="mt-4 text-sm">
                  Car Rental operates as an intermediary platform, facilitating
                  the connection between Owners who list Parking Spaces and
                  Drivers who book Parking Spaces through the Platform.
                </li>
                <li className="mt-4 text-sm">
                  Car Rental is not a property owner, supplier, or operator of
                  any Parking Space. It acts solely as a facilitator of the
                  booking process and does not provide any parking services
                  directly.
                </li>
              </ol>
            </li>
            <li className="mt-4 text-sm">
              <p className="font-bold ml-4 text-sm"> USAGE</p>
              <p className="mt-4 text-sm">
                <u>Eligibility:</u> To use this website, you must be at least 18
                years old. If you are under the legal age in your country,
                please do not use this site. You shall use this site in
                accordance with all applicable laws, legislation, rules, and
                regulations. If you violate any of the restrictions in these
                conditions, you agree to compensate Car Rental for any losses,
                expenses, or damages incurred as a result of such a breach.
              </p>
            </li>
            <li className="mt-4 text-sm">
              <p className="font-bold text-sm ml-4">
                REGISTRATION AND USE OF THE PLATFORM
              </p>
              <ol className="list-disc text-sm ml-4">
                <li className="mt-4 text-sm">
                  In order to reserve a Parking Space or create a Listing, you
                  must register on the Platform. As an unregistered visitor, you
                  may view Listings, but you cannot make reservations.
                </li>
                <li className="mt-4 text-sm">
                  By registering on the Platform, you agree to provide accurate
                  and complete information and to maintain the confidentiality
                  of your account credentials. You are solely responsible for
                  all activities that occur under your account.
                </li>
                <li className="mt-4 text-sm">
                  Car Rental reserves the right to suspend or terminate your
                  account if it believes that you have violated these Terms or
                  engaged in any fraudulent or illegal activities on the
                  Platform.
                </li>
              </ol>
            </li>
            <li className="mt-4 text-sm">
              <p className="font-bold ml-4 text-sm">BOOKING PROCESS</p>
              <ol className="list-disc ml-4 text-sm">
                <li className="mt-4 text-sm">
                  When a booking is made on the Car Rental platform, the Driver
                  enters into a contract with Car Rental. Car Rental, as an
                  intermediary, works with third-party Owners to provide the
                  service requested by the Driver.
                </li>
                <li className="mt-4 text-sm">
                  The Confirmation Email sent by Car Rental to both the Driver
                  and the Owner upon completion of the Booking will contain the
                  details of the parties involved, the Parking Space, and the
                  proposed Rental Period.
                </li>
                <li className="mt-4 text-sm">
                  Car Rental endeavors to ensure the accuracy of the
                  information provided on the Platform, but it does not
                  guarantee the availability, quality, legality, or suitability
                  of any Parking Space listed by the Owner.
                </li>
              </ol>
            </li>
            <li className="mt-4 text-sm">
              <p className="font-bold ml-4 text-sm">LIABILITY AND DISPUTES</p>
              <ol className="list-disc ml-4 text-sm">
                <li className="mt-4 text-sm">
                  Car Rental is not responsible for any actions, omissions, or
                  negligence of the Owners or Drivers using the Platform. Any
                  disputes or issues arising between Owners and Drivers must be
                  resolved directly between the parties involved. Car Rental
                  shall not be liable for any damages, losses, or expenses
                  incurred as a result of such disputes.
                </li>
                <li className="mt-4 text-sm">
                  Car Rental shall not be liable for any damages, losses, or
                  expenses arising from the use of the Platform or any Parking
                  Space listed on the Platform. Users of the Platform assume all
                  risks associated with their use of the Platform and the
                  services provided by Owners.
                </li>
                <li className="mt-4 text-sm">
                  Car Rental does not provide any warranties or guarantees
                  regarding the suitability, availability, or quality of any
                  Parking Space listed on the Platform. Users are solely
                  responsible for verifying the accuracy and appropriateness of
                  any information provided by Owners.
                </li>
              </ol>
            </li>
            <li className="mt-4 text-sm">
              <p className="font-bold ml-4 text-sm">
                EXCLUSION OF LIABILITY FOR EXTERNAL LINKS
              </p>
              <p className="mt-4 text-sm">
                The Website may provide links to external Internet sites. SPOT
                FINDER hereby declares explicitly that it has no influence on
                the layout or content of the linked pages and dissociates itself
                expressly from all contents of all linked pages of third
                parties. By using this Website and accessing the external links,
                you acknowledge and agree that:
              </p>
              <ol className="list-disc ml-4 text-sm">
                <li className="mt-4 text-sm">
                  <u>Content Control: </u> Car Rental has no control over the
                  layout, accuracy, completeness, legality, or appropriateness
                  of the content on the linked pages. The inclusion of any
                  external link does not imply endorsement or affiliation with
                  the linked website or its content. Car Rental shall not be
                  held responsible or liable for any information, materials, or
                  content displayed on the linked pages.
                </li>
                <li className="mt-4 text-sm">
                  <u>Liability Disclaimer: </u>Car Rental shall not be liable
                  for any damages, losses, or liabilities incurred as a result
                  of your use of, or reliance on, any information, products,
                  services, or content available on or through the linked
                  websites. This includes, but is not limited to, direct or
                  indirect damages, consequential or incidental damages, loss of
                  profits, or any other loss or damage.
                </li>
                <li className="mt-4 text-sm">
                  <u>Privacy and Data Processing: </u>Our privacy and cookie
                  notice do not apply to any collection and processing of your
                  personal data on or through the external linked websites. You
                  are solely responsible for reviewing and understanding the
                  privacy policies and terms of use of the linked websites
                  before providing any personal information or engaging in any
                  transactions.
                </li>
                <li className="mt-4 text-sm">
                  <u>Third-Party Websites: </u>Your use of any external links
                  provided on this Website is at your own risk. Car Rental
                  shall not be responsible for the availability, accuracy,
                  reliability, or quality of any products, services, or content
                  on the linked websites. Any complaints, claims, or disputes
                  arising from your use of the linked websites should be
                  directed to the relevant third-party website.
                </li>
                <li className="mt-4 text-sm">
                  <u>Indemnification:</u> You agree to indemnify, defend, and
                  hold Car Rental harmless from and against any claims,
                  liabilities, damages, losses, costs, or expenses arising out
                  of or in connection with your use of the linked websites.
                </li>
              </ol>
            </li>
            <li className="mt-4 text-sm">
              <p className="font-bold text-sm ml-4">INFORMATION ON THE WEBSITE</p>
              <p className="mt-4 text-sm">
                The information on the Website is provided for general
                information purposes only and does not constitute advice. While
                Car Rental has made efforts to ensure the accuracy and
                completeness of the information, texts, documents, graphics,
                and/or other services/information provided on the Website, they
                may contain errors or be otherwise incorrect or incomplete. By
                using this Website, you acknowledge and agree that:
              </p>
              <ol className="list-disc ml-4 text-sm">
                <li className="mt-4 text-sm">
                  <u>Accuracy and Completeness:</u> Car Rental does not
                  guarantee that the Website and/or the information provided are
                  free of errors, defects, malware, and viruses, or that the
                  information is correct, up to date, and accurate. You should
                  not rely solely on the information provided on the Website and
                  should seek professional advice or verification before making
                  any decisions or taking any actions based on such information.
                </li>
                <li className="mt-4 text-sm">
                  <u>Limitation of Liability:</u> To the maximum extent
                  permitted under applicable law, Car Rental shall not be
                  liable for any damages resulting from the use or inability to
                  use the Website, including damages caused by malware, viruses,
                  or any incorrectness or incompleteness of such information or
                  the Website, unless such damage is the result of any willful
                  misconduct or gross negligence on the part of Car Rental.
                </li>
                <li className="mt-4 text-sm">
                  <u>Electronic Communication:</u> Car Rental shall not be
                  liable for damages resulting from the use of (or the inability
                  to use) electronic means of communication with this Website.
                  This includes, but is not limited to, damages resulting from
                  the failure or delay in the delivery of electronic
                  communications, interception or manipulation of electronic
                  communications by third parties, or by computer programs used
                  for electronic communications, and transmission of viruses.
                </li>
                <li className="mt-4 text-sm">
                  <u>User Responsibility:</u> It is your responsibility to
                  ensure the security and integrity of your computer system and
                  electronic devices when accessing the Website. You should take
                  appropriate measures to protect against viruses, malware, or
                  other harmful components that may be present on the Internet.
                </li>
              </ol>
            </li>
            <li className="mt-4 text-sm">
              <p className="font-bold  text-smml-4">DATA PRIVACY</p>
              <p className="mt-4 text-sm">
                Car Rental collects and processes your personal data according
                to the privacy and cookie notice. Please familiarize yourself
                with Car Rental’s Privacy policy displayed at the bottom of our
                webpage.
              </p>
            </li>
            <li className="mt-4 text-sm">
              <p className="font-bold text-sm ml-4">UNSOLICITED IDEAS</p>
              <p className="mt-4 text-sm">
                In the event that you post unsolicited ideas and/or materials,
                whether consisting of texts, images, sounds, software,
                information, or otherwise (collectively referred to as
                "Materials") on this Website or send them to Car Rental by
                e-mail or any other means, you acknowledge and agree to the
                following:
              </p>
              <ol className=" ml-4 text-sm list-disc">
                <li className="mt-4 text-sm">
                  By submitting the Materials, you grant Car Rental an
                  irrevocable, free of charge, non-exclusive, and worldwide
                  right to use, copy, adapt, modify, publish, and/or
                  commercially exploit such Materials to the fullest extent
                  permitted by applicable law. This right includes the right to
                  use the Materials in whatever form and via all media known and
                  to date unknown for the duration of the intellectual property
                  rights in the Materials. Car Rental shall not be bound by any
                  confidentiality obligation in respect of such Materials.
                </li>
                <li className="mt-4 text-sm">
                  To the maximum extent permitted under applicable law, you
                  hereby indemnify and hold Car Rental harmless from and
                  against all actions, claims, and liabilities suffered,
                  incurred, or sustained by Car Rental as a result of the use
                  and/or exploitation of the Materials infringing the
                  intellectual property rights of any third party or otherwise
                  being unlawful towards and
                </li>
                <li className="mt-4 text-sm">
                  third party and Car Rental shall have no obligation to
                  review, evaluate, or use any of the Materials submitted by
                  you. Car Rental reserves the right, in its sole discretion,
                  to remove or delete any Materials posted on the Website or
                  sent to Car Rental that is deemed inappropriate, infringing,
                  unlawful, or in violation of these Terms and Conditions.
                </li>
              </ol>
            </li>
            <li className="mt-4 text-sm">
              <p className="font-bold ml-4 text-sm">PARKING SPACES</p>
              <p className="mt-4 text-sm">
                You acknowledge and agree to the following terms and conditions
                regarding parking spaces listed on the Platform:
              </p>
              <ol className="list-disc text-sm ml-4">
                <li className="mt-4 text-sm">
                  <u>Limited Responsibility: </u>You agree that the Platform is
                  not responsible for the parking spaces, other than to offer
                  the Services described in this Agreement, which include
                  managing and verifying bookings and collecting fees. We do not
                  own or operate the parking spaces listed on the Platform.
                </li>
                <li className="mt-4 text-sm">
                  <u>No Guarantee of Appropriateness: </u>While we make every
                  effort to ensure that the parking spaces displayed on the
                  Platform are of suitable quality, we make no guarantee as to a
                  parking space's appropriateness for the driver's needs. We
                  rely on the information provided by the owners of the parking
                  spaces, and while we make reasonable attempts to verify such
                  information, we provide no assurance regarding the accuracy or
                  reliability of such facts.
                </li>
                <li className="mt-4 text-sm">
                  <u>Owner Responsibility: </u>We are not responsible for the
                  location or quality of a parking space, its availability, or
                  the behavior of the owner. The owners are solely responsible
                  for their parking spaces and any services provided in
                  connection with them.
                </li>
                <li className="mt-4 text-sm">
                  <u>No Liability: </u>We make every effort to ensure that our
                  owners provide a good service and that their parking spaces
                  meet the driver's expectations. However, we accept no
                  responsibility and will have no liability if the parking space
                  or the owner's services do not meet the driver's requirements
                  or if the driver finds them unsatisfactory in any way. Any
                  issues or complaints related to the parking space should be
                  directed to Car Rental after entering into an agreement.
                </li>
                <li className="mt-4 text-sm">
                  <u>Disputes: </u>In the event of any disputes between the
                  driver and the owner regarding the parking space or services
                  provided, we encourage you to contact Car Rental to
                  facilitate resolution. However, we are not responsible for
                  resolving disputes between users or for any damages or losses
                  arising from such disputes.
                </li>
              </ol>
            </li>
            <li className="mt-4 text-sm">
              <p className="font-bold ml-4 text-sm">PAYMENTS</p>
              <ol className="list-disc text-sm">
                <li className="ml-4 mt-4 text-sm">
                  <p>Payments and Billings:</p>
                  <p className="mt-4 text-sm">
                    <u>Payment Request:</u> We will request payment from the
                    driver after the appropriate dates and hours have been
                    specified. We will also require confirmation from the driver
                    that they accept these Terms.
                  </p>
                  <p className="mt-4 text-sm">
                    <u>Booking Confirmation:</u> Once we have received payment
                    and the driver has approved these Terms, we will submit the
                    booking to the owner for confirmation. A booking
                    confirmation email ("Confirmation Email") will be sent to
                    the driver, which will include a link to the dashboard to
                    obtain the owner's contact phone number and complete booking
                    instructions.
                  </p>
                  <p className="mt-4 text-sm">
                    <u>Discharge of Payment Obligations:</u> The owner agrees
                    that paying the fees to Car Rental fully discharges the
                    driver's payment obligations for that booking.
                  </p>
                  <p className="mt-4 text-sm">
                    <u>Payment Methods:</u> Payments can be made using PayPal
                    and credit cards. By providing a credit card or other
                    accepted payment method, you represent and warrant that you
                    are authorized to use the designated payment method and that
                    you authorize us (or our third-party payment processor) to
                    charge your payment method for all charges you incur for the
                    purchase of any subscriptions or other products. You are
                    responsible for and agree to pay all such charges. If
                    authorization for charges cannot be obtained or if
                    authorized charges are reversed or charged back for any
                    reason, we may take appropriate actions, including canceling
                    or suspending undelivered portions of orders, making
                    subsequent attempts to charge your payment method, and using
                    other lawful means to collect outstanding amounts. You will
                    remain responsible for all applicable charges.
                  </p>
                  <p className="mt-4 text-sm">
                    <u>Refund Policy:</u> All refunds will be processed in 5-7
                    working days.
                  </p>
                </li>
                <li className="ml-4 mt-4 text-sm">
                  <p>Taxes:</p>
                  <p className="mt-4 text-sm">
                    The owner is responsible for timely payment of all fees and
                    relevant taxes, including sales taxes, value added taxes,
                    income taxes, goods and services taxes, and other similar
                    local, state, and federal indirect taxes, withholding taxes,
                    and personal or corporate income taxes ("Taxes") under this
                    agreement.
                  </p>
                  <p className="mt-4 text-sm">
                    In the event the owner's payment method fails, we may
                    collect fees owed through other collection mechanisms. We
                    reserve the right to charge the owner for any additional
                    fees and expenses incurred in attempting to collect fees,
                    including legal fees and costs associated with collection
                    efforts, the use of an external debt collection agency, or
                    the initiation of legal proceedings.
                  </p>
                </li>
              </ol>
            </li>
            <li className="mt-4 text-sm">
              <p className="font-bold ml-4 text-sm">PROHIBITED USES</p>
              <p className="mt-4 text-sm">
                You agree not to use the Website for any purpose that is
                prohibited by law or in a manner that violates any applicable
                laws, regulations, or the terms of this agreement. Prohibited
                uses of the Website include, but are not limited to, the
                following:
              </p>
              <ol className=" ml-4 list-disc">
                <li className="mt-4 text-sm">
                  <u> Unlawful Activities:</u> Engaging in any activity that is
                  illegal, fraudulent, deceptive, or in violation of any local,
                  state, national, or international law or regulation.
                </li>
                <li className="mt-4 text-sm">
                  <u>Unauthorized Access:</u> Attempting to gain unauthorized
                  access to the Website, accounts, computer systems, or networks
                  connected to the Website through hacking, password mining, or
                  any other means.
                </li>
                <li className="mt-4 text-sm">
                  <u>Malicious Activities:</u> Engaging in any activity that
                  disrupts, interferes with, or poses a threat to the security,
                  integrity, or functioning of the Website, its users, or any
                  connected networks. This includes the transmission of viruses,
                  malware, or any other harmful or disruptive code.
                </li>
                <li className="mt-4 text-sm">
                  <u>Intellectual Property Infringement: </u>Engaging in any
                  activity that infringes upon or violates the intellectual
                  property rights or proprietary rights of others, including but
                  not limited to copyrights, trademarks, patents, or trade
                  secrets.
                </li>
                <li className="mt-4 text-sm">
                  <u>Unauthorized Use: </u>Using the Website in a manner that
                  exceeds the scope of authorized access or use granted by Spot
                  Finder or violates any contractual or legal restrictions
                  applicable to the Website.
                </li>
                <li className="mt-4 text-sm">
                  <u>Data Collection and Harvesting:</u> Collecting, harvesting,
                  or storing personal information or data about other users of
                  the Website without their explicit consent or in violation of
                  applicable data protection laws.
                </li>
                <li className="mt-4 text-sm">
                  <u>Spam and Unsolicited Communications: </u> • Sending
                  unsolicited or unauthorized advertising, promotional
                  materials, spam, junk mail, or any other form of solicitation.
                </li>
                <li className="mt-4 text-sm">
                  <u>Impersonation: </u>Impersonating any person or entity, or
                  falsely representing your affiliation with any person or
                  entity.
                </li>
                <li className="mt-4 text-sm">
                  <u>Content Violation: </u>Posting, uploading, or transmitting
                  any content that is unlawful, harmful, abusive, defamatory,
                  obscene, offensive, or otherwise objectionable, or that
                  infringes upon the rights of others.
                </li>
                <li className="mt-4 text-sm">
                  <u>Reverse Engineering: </u>Reverse engineering, decompiling,
                  disassembling, or otherwise attempting to discover the source
                  code, algorithms, or underlying technology of the Website or
                  any software used in connection with the Website.
                </li>
                <li className="mt-4 text-sm">
                  <u>Unauthorized Commercial Activities: </u>Engaging in any
                  commercial activities, such as advertising, selling, or
                  promoting goods or services, without prior written consent
                  from Car Rental.
                </li>
              </ol>
              <p className="mt-4 text-sm">
                Violation of this "Prohibited Uses" clause may result in the
                termination of your access to the Website and may also expose
                you to civil or criminal liability.
              </p>
            </li>
            <li className="mt-4 text-sm">
              <p className="font-bold ml-4 text-sm">RENTAL PERIOD END/OVERSTAYS</p>
              <p className="mt-4 text-sm">
                The Driver shall depart and stop using the Parking Space at the
                end of the Rental Period. The precise time of departure from the
                Parking Space will be specified in the Confirmation Email.
              </p>
              <p className="mt-4 text-sm">
                Overstays parking will be charged current hourly/daily rate for
                the extra time that the car remains parked. Based on the
                availability of the garage and the bookings made in the garage,
                Car Rental shall have the sole discretion to determine whether
                or not the motorist should pay. The Driver is obligated by
                whatever decision Car Rental makes.
              </p>
              <p className="mt-4 text-sm">
                The Owner authorizes Car Rental to collect any such additional
                fees from the Driver on his or her behalf.
              </p>
              <p className="mt-4 text-sm">
                If the Driver remains in the Parking Space for more than 3
                hours, the Owner reserves the right to instruct a third party to
                remove the Driver's vehicle(s) (and the Driver will be charged
                for the costs of any such action).
              </p>
            </li>
            <li className="mt-4 text-sm">
              <p className="font-bold ml-4 text-sm">TERMINATION</p>
              <p className="mt-4 text-sm">
                We reserve the right to terminate your Account at our
                discretion, with or without cause, and without any liability to
                you. Such termination may occur with or without prior notice and
                at any time.
              </p>
              <p className="mt-4 text-sm">
                In the event of termination, the following actions may be taken
                by us, at our discretion and without prior notice or explanation
                to you:
              </p>
              <ol className="list-disc ml-4 text-sm">
                <li className="mt-4 text-sm">
                  <u>Deactivation or Suspension:</u> Your Account will be
                  deactivated or suspended, your password will be disabled, and
                  you will no longer have access to the Platform or your
                  Account. Additionally, you will not be able to seek assistance
                  from our customer service.
                </li>
                <li className="mt-4 text-sm">
                  <u>Termination of Bookings:</u> Any pending or accepted
                  bookings, whether as an Owner or a Driver, will be immediately
                  terminated.
                </li>
                <li className="mt-4 text-sm">
                  <u>Communication of Cancellations:</u> We may communicate to
                  Drivers or Owners that a potential or confirmed booking has
                  been cancelled.
                </li>
                <li className="mt-4 text-sm">
                  <u>Refunds:</u> We may refund Drivers in full for any
                  confirmed reservations, regardless of pre-existing
                  cancellation policies.
                </li>
                <li className="mt-4 text-sm">
                  <u>Alternate Accommodations:</u> We may contact Drivers to
                  inform them about potential alternate Accommodations available
                  on the Platform.
                </li>
                <li className="mt-4 text-sm">
                  <u>Compensation:</u> You will not be entitled to any
                  compensation for reservations or bookings, even if they were
                  confirmed, that were cancelled due to the suspension,
                  deactivation, or termination of your Account.
                </li>
              </ol>
              <p className="mt-4 text-sm">
                You have the right to cancel your Account at any time by using
                the "Cancel Account" feature on the Platform or by sending an
                email to us. Please note that if your Account is cancelled, we
                are not obligated to delete or return any content you have
                posted on the Platform.
              </p>
              <p className="mt-4 text-sm">
                Please be aware that termination of your Account may result in
                the loss of access to certain features, services, or content
                within the Platform.
              </p>
            </li>
            <li className="mt-4 text-sm">
              <p className="font-bold ml-4 text-sm">INDEMNIFICATION</p>
              <p className="mt-4 text-sm">
                You agree to indemnify, defend, and hold harmless Car Rental
                and its affiliates, directors, officers, employees, agents, and
                representatives from and against any and all claims,
                liabilities, damages, losses, costs, expenses, or demands,
                including reasonable attorneys' fees and court costs, arising
                out of or in connection with:
              </p>
              <ol className="list-disc ml-4 text-sm">
                <li className="mt-4 text-sm">
                  Your use of the Website, including but not limited to any
                  violation of these Terms and Conditions or any applicable laws
                  or regulations;
                </li>
                <li className="mt-4 text-sm">
                  Your violation of any rights of any third party, including but
                  not limited to intellectual property rights, privacy rights,
                  or contractual rights;
                </li>
                <li className="mt-4 text-sm">
                  Your interaction with any other users of the Website,
                  including Owners or Drivers;
                </li>
                <li className="mt-4 text-sm">
                  Any content you submit, post, transmit, or otherwise make
                  available through the Website;
                </li>
                <li className="mt-4 text-sm">
                  Your violation of any laws or regulations applicable to the
                  use of the Website or the services provided by Car Rental;
                </li>
                <li className="mt-4 text-sm">
                  Any damage or loss arising out of or resulting from any act or
                  omission by you, including but not limited to bodily injury,
                  property damage, or financial loss;
                </li>
                <li className="mt-4 text-sm">
                  Any claim or dispute between you and any other user of the
                  Website, including Owners or Drivers;
                </li>
                <li className="mt-4 text-sm">
                  Any unauthorized access to or use of the Website, including
                  but not limited to any breach of security or unauthorized use
                  of your Account; or
                </li>
                <li className="mt-4 text-sm">
                  Any breach of any representations, warranties, or obligations
                  under these Terms and Conditions.
                </li>
              </ol>
              <p className="mt-4 text-sm">
                You agree to cooperate fully in the defense of any claim and to
                provide all necessary information, assistance, and cooperation
                to Car Rental. Car Rental reserves the right, at its own
                expense, to assume the exclusive defense and control of any
                matter otherwise subject to indemnification by you. You shall
                not settle any matter without the prior written consent of SPOT
                FINDER.
              </p>
            </li>
            <li className="mt-4 text-sm">
              <p className="font-bold ml-4 text-sm">DISCLAIMER</p>
              <p className="mt-4 text-sm">
                Your access to and use of the Services and content provided on
                the Car Rental website are at your own risk. You acknowledge
                and agree that the Services are provided to you on an "AS IS"
                and "AS AVAILABLE" basis. To the maximum extent permitted under
                applicable law, the Car Rental entities, including Car Rental
                founders, officers, directors, employees, agents,
                representatives, and partners, DISCLAIM ALL WARRANTIES AND
                CONDITIONS, WHETHER EXPRESS OR IMPLIED, INCLUDING BUT NOT
                LIMITED TO MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR
                NON-INFRINGEMENT.
              </p>
              <p className="mt-4 text-sm">
                Car Rental makes no warranty and disclaims all responsibility
                and liability for the completeness, accuracy, availability,
                timeliness, security, or reliability of the Services or any
                Content. Furthermore, Car Rental disclaims any responsibility
                or liability for any harm to your computer system, loss of data,
                or other harm that may result from your access to or use of the
                Services or any Content. Car Rental also disclaims any
                responsibility or liability for the deletion of, or the failure
                to store or transmit, any Content and other communications
                maintained by the Services. Moreover, Car Rental does not
                warrant or guarantee that the Services will meet your
                requirements or be available on an uninterrupted, secure, or
                error-free basis. No advice or information, whether oral or
                written, obtained from Car Rental or through the Services, will
                create any warranty not expressly stated herein.
              </p>
              <p className="mt-4 text-sm">
                The Services may include links to third-party websites or
                resources. You acknowledge and agree that Car Rental is not
                responsible or liable for the availability or accuracy of such
                websites or resources, or for the content, products, or services
                available from such websites or resources. The inclusion of
                links to such websites or resources does not imply endorsement
                by Car Rental of the content, products, or services available
                from such websites or resources. You acknowledge sole
                responsibility for and assume all risk arising from your use of
                any such websites or resources.
              </p>
              <p className="mt-4 text-sm">
                Car Rental reserves the right to change any and all Content and
                to modify, suspend, or terminate access to the website (or any
                features or functionality of the website) and the Products at
                any time without notice and without obligation or liability to
                you. Reference to any products, services, processes, or other
                information by trade name, trademark, manufacturer, supplier,
                vendor, or otherwise does not constitute or imply endorsement,
                sponsorship, or recommendation by Car Rental, or any
                affiliation therewith. Please note that some jurisdictions may
                not allow the disclaimer of implied terms in contracts with
                consumers, so some or all of the disclaimers in this section may
                not apply to you.
              </p>
              <p className="mt-4 text-sm">
                It is important to note that the above disclaimer is a general
                statement and may need to be reviewed and customized to comply
                with specific Indian laws and regulations. It is advisable to
                seek legal advice to ensure compliance with applicable laws and
                regulations.
              </p>
            </li>
            <li className="mt-4 text-sm">
              <p className="font-bold ml-4 text-sm">DISPUTES BETWEEN USERS</p>
              <p className="mt-4 text-sm">
                In the event of a disagreement between the parties regarding the
                Parking Space or any other matter during or after the Rental
                Period, both parties acknowledge and agree that Car Rental
                shall have the authority to make a final decision, and both
                parties shall be bound by such decision. Car Rental is
                authorized to collect funds from either party, when practicable,
                to enforce the terms of the settlement.
              </p>
              <p className="mt-4 text-sm">
                Both parties grant Car Rental the exclusive discretion to
                handle any disputes or complaints and agree to abide by any
                decisions made by Car Rental in such cases, including the
                authority to demand refunds or compensation payments up to a
                maximum amount of INR______.
              </p>
              <p className="mt-4 text-sm">
                Neither party shall be held liable to the other for any lost
                profits, data loss, or costs incurred in procuring substitute
                goods or services, or for any consequential, special, indirect,
                or exemplary damages arising out of this agreement, the Parking
                Space, or the Rental Period, regardless of the cause and under
                any theory of liability (including negligence), even if advised
                of the possibility of such damages.
              </p>
              <p className="mt-4 text-sm">
                The liability of the Owner for all losses (except for willful or
                reckless property damage, fraud, or personal injury or death
                resulting from negligence) is limited to either the cost of
                securing a replacement Parking Space for the agreed Rental
                Period or the total amount of Parking Space fees and charges
                paid by the Driver, whichever is greater, plus INR______.
              </p>
              <p className="mt-4 text-sm">
                The liability of the Driver for all losses (except for willful
                or reckless property damage, fraud, or personal injury or death
                resulting from negligence) is limited to the total amount of
                Parking Space fees and charges paid or payable by the Driver,
                plus INR______.
              </p>
            </li>
            <li className="mt-4 text-sm">
              <p className="font-bold ml-4 text-sm">ARBITRATION</p>
              <p className="mt-4 text-sm">
                By agreeing to these terms and conditions, you hereby waive your
                right to participate in any class action lawsuit or class-wide
                arbitration under Indian laws. Any dispute, controversy, or
                claim arising out of or relating to this agreement shall be
                resolved through individual arbitration. The arbitration
                proceedings shall be conducted in accordance with the
                Arbitration and Conciliation Act, 1996, or any successor
                legislation, and shall take place in{" "}
                <mark>Pune, Maharashtra,</mark> India.
              </p>
              <p className="mt-4 text-sm">
                The arbitrator shall be appointed by mutual agreement between
                the parties, and if no agreement can be reached, the appointment
                shall be made by the Appropriate Authority or Arbitration
                Institution. The decision of the arbitrator shall be final and
                binding on both parties.
              </p>
              <p className="mt-4 text-sm">
                You understand and acknowledge that by waiving your right to
                participate in a class action lawsuit or class-wide arbitration,
                you are giving up your ability to pursue claims on a collective
                or representative basis. This clause does not limit your right
                to seek individual relief through arbitration or court
                proceedings to the extent permitted by applicable law.
              </p>
            </li>
            <li className="mt-4 text-sm">
              <p className="font-bold ml-4 text-sm">CHANGES CLAUSE</p>
              <p className="mt-4 text-sm">
                If Car Rental decides to make changes to these general terms
                and conditions, we will notify you by posting the revised terms
                and conditions on the Website. It is your responsibility to
                regularly review the terms and conditions to stay informed about
                any changes. Your continued use of the Services after the
                posting of any revised terms and conditions constitutes your
                acceptance of the changes.
              </p>
              <p className="mt-4 text-sm">
                Any changes to these terms and conditions will apply
                prospectively and will not affect the rights and obligations
                that arose prior to the effective date of the changes. If you do
                not agree to the revised terms and conditions, you must
                discontinue your use of the Services.
              </p>
              <p className="mt-4 text-sm">
                Car Rental reserves the right to modify, suspend, or
                discontinue the Services (or any part thereof) at any time
                without prior notice or liability.
              </p>
              <p className="mt-4 text-sm">
                It is important to note that this clause applies specifically to
                the general terms and conditions and does not cover changes to
                other agreements or policies that may be applicable to specific
                services or features provided by Car Rental.
              </p>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default TermsAndCondition;
